<template>
    <main id="view-search-machines-filters" class="products-filters-view">
        <form class="filters-wrapper" @submit.prevent="search()">
            <h1 class="title-with-icon mobile-top-icon">
                <span class="icon-search" :class="brandColor"></span>
                {{ $t("i_search_a_machine") }}
            </h1>

            <h2 class="filter-step-title" v-if="categories">1. {{ $t("select_machine_categorie") }}</h2>

            <div class="categories-list-container">
                <div class="categories-list">
                    <div
                        class="category-item"
                        :class="{'current': category.code === selectedCategory}"
                        v-for="category in asyncCategories"
                        :key="category.code"
                        :data-tracking="`machine_search__button__${category.code}`"
                        @click="selectCategory(category.code)"
                    >
                        <img
                            v-if="categoryPicture(category)"
                            :src="categoryPicture(category)"
                            alt=""
                            width="462"
                            height="300"
                            class="picture"
                        >
                        <div class="title">{{ category.label }}</div>
                        <span class="radio-container">
                            <b-radio v-model="selectedCategory" :native-value="category.code"/>
                        </span>
                    </div>
                </div>
            </div>

            <div id="filters" :class="{'is-loading': !enableSearch}" ref="filtersContainer">
                <h2 class="filter-step-title" v-if="filters.length > 0">2. {{ $t("additional_filters") }}</h2>
                <transition-group name="fade" tag="div">
                    <div
                        class="filter-block"
                        v-for="(filter, index) in filters"
                        :key="filter.attribute"
                    >
                        <h3 class="colored-label" :class="brandColor">{{ displayFilterTitle(filter) }}</h3>
                        <div class="slider-container" v-if="filter.type === 'slider'">
                            <div class="columns is-inline-flex is-vcentered slider-inputs">
                                <div class="column is-narrow">{{ $t("from") }}</div>
                                <div class="column is-narrow input-column">
                                    <b-input
                                        v-model="filter.minValue"
                                        size="is-large"
                                        autocomplete="new-password"
                                        @blur="updateSliderFromInput(index);searchResults()"
                                        rounded
                                    />
                                </div>
                                <div class="column is-narrow">{{ $t("to") }}</div>
                                <div class="column is-narrow input-column">
                                    <b-input
                                        v-model="filter.maxValue"
                                        size="is-large"
                                        autocomplete="new-password"
                                        @blur="updateSliderFromInput(index);searchResults()"
                                        rounded
                                    />
                                </div>
                                <div class="column is-narrow">{{ filter.unit }}</div>
                            </div>
                            <div class="columns is-vcentered is-mobile slider-range">
                                <div class="column edges is-narrow">{{ filter.min }}</div>
                                <div class="column">
                                    <vue-slider
                                        v-model="filter.slider"
                                        :dotSize="38"
                                        :min="filter.min"
                                        :max="filter.max"
                                        :interval="1"
                                        :tooltip-formatter="filter.formatter"
                                        @change="updateSlide(index)"
                                    />
                                </div>
                                <div class="column edges is-narrow">{{ filter.max }}</div>
                            </div>
                        </div>
                        <div class="select-container" v-if="filter.type === 'select' || filter.type === 'boolean'">
                            <b-select v-model="filter.value" size="is-large" rounded @change.native="searchResults()">
                                <option
                                    v-for="option in filter.options"
                                    :value="option.code"
                                    :key="option.code"

                                >{{ option.label }}</option>
                            </b-select>
                        </div>
                    </div>
                </transition-group>


            </div>


          <div class="is-centered is-size-5 is-size-6-mobile results-count">
            <template v-if="resultsLoaded ">
              <strong>{{ $tc('results_count', total) }}</strong>

            </template>
            <template v-else-if="selectedCategory">

              <strong>{{ $tc('search_in_progress') }}</strong>

            </template>
          </div>

            <transition name="fade">



                <button
                    type="submit"
                    class="button is-primary is-large is-rounded is-uppercase with-small-side-padding submit-search"
                    :class="brandBackgroundColor"
                    v-if="enableSearch"
                    :disabled="!total || !resultsLoaded"
                >

                    <span>{{ $t('validate') }}</span>
                    <span class="icon-arrow-right is-tiny is-right-side"></span>


                </button>
            </transition>
        </form>
    </main>
</template>


<script>
import { mapState, mapGetters } from 'vuex'

import formMixins from "@/common/mixins/form";
import filtersMixins from "@/common/mixins/filters";

import productService from "@/services/serli/product";

import VueSlider from "vue-slider-component";
import {convertFiltersValuesBackToMetric} from "@/common/helpers";

export default {
    name: 'searchMachinesFilters',
    mixins: [
        formMixins,
        filtersMixins
    ],
    components: {
        VueSlider
    },
    data() {
        return {
            selectedCategory: null,
            filters: [],
            enableSearch: false,
            total:0,
            resultsLoaded:false,
            firstLoad:true,
        };
    },
    computed: {
        ...mapState({
            category: state => state.searchMachines.category,
            unitType:state=>state.settings.unitType,
            asyncCategories : state =>state.settings.asyncCategories,
        }),
        ...mapGetters({
            localeKebabFormat: 'settings/localeKebabFormat'
        }),
    },
    created() {
        // Si on detecte le param init, on supprimer les filtres & categorie du store pour reset la recherche
        if (this.$route.query.init){
            this.$store.commit('searchMachines/setCategory', null);
            this.$store.commit('searchMachines/deleteFilters');
        }

    },
    methods: {
        async selectCategory(code, selectFromList = true) {
          this.filters=[];
          this.$store.commit('searchMachines/deleteFilters');
            this.selectedCategory = code
            this.enableSearch = false;
            const loadingComponent = this.$loading.open({ container: this.$refs.filtersContainer })

            await this.loadFilters(code)
            this.enableSearch = true;
            loadingComponent.close()

            if(selectFromList) {
                let topScroll = document.getElementById('filters').offsetTop + 70;
                if(parseInt(window.innerWidth) > 768) topScroll = document.getElementById('filters').offsetTop;
                setTimeout(() => {
                    window.scroll({
                        top: topScroll,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 150);
            }
        this.firstLoad=true;
         this.searchResults();

        },
      searchResults: _.debounce(
        async function() {
          let filters = JSON.parse(JSON.stringify(this.filters));
          filters = await convertFiltersValuesBackToMetric(filters);

          this.resultsLoaded = false;

          productService.list({
            filters: filters
          }, {
            productType: 'machines',
            brand: this.$store.state.settings.brand,
            category: this.selectedCategory,
            full: false,
            size: 1,
            page : 1,
            locale: this.localeKebabFormat,

          })
              .then((response) => {
                if(response.data.code === 200) {
                  this.total = response.data.data.total;
                  if(this.total>0 && !this.firstLoad) this.reloadFilters(response.data.data);
                }
              })
              .finally(() => {
                this.updateAllSlide()
                this.resultsLoaded = true;
                this.firstLoad = false;

              });
        }, 500),
        async loadFilters(code) {

            productService.filters('machines',code, null, {
                locale: this.localeKebabFormat,
                unit: this.$store.state.settings.unitType
            })
            .then(async response => {
              if (response.data.code === 200) {
                // const filterDatas = await this.generateFiltersArray(response.data.data);
                const filterDatas = response.data.data.filter(x => {
                  return x.code.search('subcategory') === -1
                });
                this.filters = await this.generateFiltersArray(filterDatas);

              }
              else
                this.filters = [];


            });

        },
        reloadFilters(response) {
          var newFilters=[]
          this.filters.forEach((x,index)=>{

            if(x.type==="slider") {
              const attribute=response.possibleAttributeValues.find(y=>y.code===x.attribute)
              x.minValue=parseInt(Math.floor(attribute.values.min[this.unitType].amount.replace(',','.')))
              x.maxValue=parseInt(Math.ceil(attribute.values.max[this.unitType].amount.replace(',','.')))
            }
            newFilters.push(x)
          })
          this.filters=newFilters
        },
        categoryPicture(category) {
            try {
                return require(`@/assets/img/categories-machines/main/${category.code}.jpg`)
            } catch (e) {
                return null
            }
        },
        search() {
            let category = this.categories.find(x => x.code === this.selectedCategory);
            this.$store.commit("searchMachines/setCategory", category);
            this.$store.commit("searchMachines/setRange", null);
            this.$store.commit("searchMachines/setFilters", this.filters);
            this.$router.push({ path: "search-machines-results" });
        },
      updateSlide(index) {
        this.updateInputsFromSlider(index);
        this.resultsLoaded=false;
        this.searchResults()
      },
      updateAllSlide() {
          this.filters.forEach((x,index)=>{
            if(x.type==='slider') {
              this.updateSliderFromInput(index);
            }
          })
      }
    }
};
</script>

<style lang="scss">
@import "~@/assets/scss/config/config";

#view-search-machines-filters {
    min-height: 500px;
  .is-small-mobile {
    white-space: normal;
    height:auto
  }
    .submit-search {
        margin-top: 40px;
      .is-small-mobile {
        white-space: normal;
        height:auto
      }
        @media #{$mq_phone} {
            margin-top: 25px;
        }
    }
  .results-count{
    margin-top:40px;
  }
}
</style>
